// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8114) return "static/chunks/8114-c299e4e03365a7be.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4106 ? "b9633c63" : chunkId) + "." + {"165":"32c5ba5d60f3bad6","1227":"4c6053387cfa9603","2958":"a17e3f6ad698ca86","3800":"cd8533e8d4dde1e7","4106":"430eae371c711fda","6716":"41c1cd0e87421790"}[chunkId] + ".js";
};